<span class="badge"
	  [class.badge-icd9]="isCodeSetICD9()"
	  [class.badge-icd10]="isCodeSetICD10()"
	  [class.badge-snmd]="isCodeSetSNOMED()">
	{{practiceDiagnosis?.codeSet?.label}}
</span>
<span class="margin-left-sm">
	{{getDescription()}}
</span>
